// src/i18n/ar/views/dominioPropio.js
//
// Guía que ve el anfitrión para apuntar su dominio a la web del constructor.
// Traducción al árabe; el original con las notas largas está en es/.
//
// Marcadores que rellena la pantalla:
//   {dominio} {destino} {nombre} {tipo} {valor} {encontrado} {actual} {sitio}
//   {panel} {panelCorto}

export const dominioPropio = {
  cabecera: {
    titulo: "اربط نطاقك الخاص",
    subtitulo:
      "موقعك يظهر الآن على {actual}. وعند الانتهاء سيظهر على عنوانك المعتاد.",
    duracion: "عشر دقائق من وقتك. والباقي يتكفل به الإنترنت وحده.",
  },

  pasos: {
    uno: "نطاقك",
    dos: "السطران في {panelCorto}",
    tres: "التحقق",
    unoDetalle: "تكتب العنوان الذي تريد استخدامه",
    dosDetalle: "تنسخ سطرين في لوحة نطاقك",
    tresDetalle: "ونحن نتحقق من أن كل شيء في مكانه",
    indicador: "الخطوة {paso} من 3",
  },

  // ── Paso 1: escribir el dominio ────────────────────────────────────────────
  paso1: {
    titulo: "ما العنوان الذي تريده لموقعك؟",
    descripcion:
      "اكتب النطاق الذي اشتريته بالفعل. نحن لا نبيع النطاقات، فهذه الخطوة تربط نطاقاً يخصك أنت.",
    etiqueta: "نطاقك",
    marcador: "midominio.com",
    ayuda: "اكتبه كما هو، بدون «https://» وبدون شرطة مائلة في آخره.",

    formaTitulo: "وكيف تريد أن يظهر العنوان؟",
    formaRaiz: {
      titulo: "midominio.com",
      descripcion: "العنوان القصير، بدون أي شيء قبله. وهو الأكثر شيوعاً.",
    },
    formaWww: {
      titulo: "www.midominio.com",
      descripcion: "الشكل المعتاد منذ زمن، مع «www» في المقدمة.",
    },
    formaSubdominio: {
      titulo: "reservas.midominio.com",
      descripcion:
        "عنوان منفصل، حتى لا تمس الموقع الموجود لديك على {dominio}.",
    },
    subdominioEtiqueta: "الكلمة التي تسبق النطاق",
    subdominioMarcador: "reservas",
    subdominioAyuda: "الكلمة فقط. والباقي نضيفه نحن.",

    avisoWebExistente: {
      titulo: "هل لديك موقع على هذا العنوان بالفعل؟",
      texto:
        "إذا كان {dominio} يعرض اليوم موقعاً آخر، فسيتوقف ظهوره عند الانتهاء ويظهر هذا الموقع بدلاً منه. وإذا كنت تفضل الإبقاء عليه، فاستخدم عنواناً منفصلاً مثل reservas.{dominio}.",
    },

    boton: "متابعة",
    botonComprobando: "جاري التحقق من النطاق…",
  },

  // ── Dónde tiene el dominio ─────────────────────────────────────────────────
  proveedor: {
    pregunta: "أين اشتريت {dominio} أو أين تديره؟",
    ayuda:
      "هي الشركة التي تدفع لها التجديد كل عام. وإذا لم تتذكرها، فابحث في بريدك عن آخر فاتورة للنطاق.",
    cloudflare: "Cloudflare",
    cloudflareDetalle: "تعليمات كاملة، شاشة بشاشة",
    otro: "شركة أخرى",
    otroDetalle: "GoDaddy, IONOS, Namecheap, Dinahosting…",
    otroTexto:
      "السطور هي نفسها تماماً. الذي يتغير هو مكان الزر فقط. ابحث في لوحتك عن شيء مكتوب عليه «DNS» أو «منطقة DNS» («DNS Zone») أو «إدارة DNS» («DNS Management»)، وانسخ هناك سطور الجدول أعلاه، سطراً سطراً.",
    noLoSe: "لا أعرف",
    noLoSeTexto:
      "راسلنا وأرسل لنا نطاقك، وسنخبرك أين هو وما الذي يجب تعديله.",
  },

  // ── Paso 2: los registros ──────────────────────────────────────────────────
  paso2: {
    titulo: "الآن علينا أن نخبر نطاقك أين يوجد موقعك",
    descripcion:
      "نطاقك مجرد اسم. وهو وحده لا يوصل إلى أي مكان، إذ يجب أن يدوّن أحدهم في دفتر أن هذا الاسم يقابل خادمنا. هذا الدفتر اسمه DNS، وهو موجود في لوحة نطاقك.",

    queEsUnRegistro: {
      titulo: "ما الذي ستفعله بالضبط",
      texto:
        "ستضيف سطراً إلى ذلك الدفتر. سطراً واحداً فقط. وفيه ثلاث خانات: ما اسمه، وإلى أين يشير، وهل يمر عبر مرشّح أم لا. لا أكثر.",
      textoOtro:
        "ستضيف سطوراً إلى ذلك الدفتر. في كل سطر خانتان: ما اسمه، وإلى أين يشير. لا أكثر.",
    },

    copiaTitulo: "انسخ هذه البيانات كما هي",
    copiaAyuda:
      "استخدم أزرار النسخ. مسافة زائدة أو حرف مختلف ولن يعمل.",

    tabla: {
      tipo: "النوع",
      nombre: "الاسم",
      destino: "الوجهة",
      contenido: "المحتوى",
      proxy: "حالة الـ proxy",
      ttl: "TTL",
      valorProxy: "DNS فقط («DNS only»)، سحابة رمادية",
      valorTtl: "تلقائي («Auto»)",
    },

    copiar: "نسخ",
    copiado: "تم النسخ",
    copiarTodo: "نسخ البيانات",

    tipos: {
      cnameTitulo: "CNAME",
      cnameTexto:
        "هو إحالة: يقول إن نطاقك يُخدم من {destino}. وإذا غيّرنا الخادم يوماً ما، فلن تحتاج إلى تعديل أي شيء.",
      txtTitulo: "TXT",
      txtTexto:
        "هو ملاحظة موقّعة. لا يوصل إلى أي مكان، بل يثبت فقط أن النطاق نطاقك. ويمكن حذفه بعد أن يعمل الموقع، لكن الأسهل أن تتركه كما هو.",
    },

    nombreTitulo: "ما الذي يُكتب في «الاسم» («Name»)",
    nombreRaiz:
      "للنطاق القصير ({dominio}) اكتب علامة @ فقط. في دفتر DNS تعني هذه العلامة «النطاق وحده، بدون أي شيء قبله». لا تكتب {dominio} كاملاً.",
    nombreWww: "لـ www.{dominio} اكتب فقط: www",
    nombreSubdominio:
      "لـ {nombre}.{dominio} اكتب الكلمة التي في المقدمة فقط: {nombre}",
    nombreAviso:
      "في Cloudflare تكتب هذا الجزء فقط. وهو يضيف «.{dominio}» من تلقاء نفسه ويعرضه لك أسفل الحقل.",
    nombreAvisoOtro:
      "في معظم اللوحات تكتب هذا الجزء فقط وهي تضيف «.{dominio}». وإذا طلبت منك لوحتك الاسم كاملاً، فاكتب {nombre}.{dominio}.",
    nombreAvisoOtroRaiz:
      "إذا كانت لوحتك لا تقبل «@»، فاترك حقل الاسم فارغاً، ففي كثير منها يعني الشيء نفسه: النطاق بدون أي شيء قبله.",

    volver: "أنهيت ذلك، العودة إلى WACheckin",
    ayudaEnviar: "أرسل لي هذه البيانات بالبريد",
    ayudaEnviarTexto:
      "إذا كان من سيقوم بذلك هو المسؤول التقني لديك أو من أنشأ موقعك، فسنرسل التعليمات إلى بريدك لتعيد إرسالها له.",
  },

  // ── Cloudflare, paso a paso ────────────────────────────────────────────────
  cloudflare: {
    titulo: "نفّذها في Cloudflare",
    subtitulo: "عشر دقائق. جهّز بريد حساب Cloudflare وكلمة مروره.",

    pasos: {
      uno: "ادخل إلى dash.cloudflare.com بحسابك.",
      dos: "في الشاشة الأولى تظهر نطاقاتك. اضغط على {dominio}.",
      tres:
        "من القائمة الجانبية افتح «DNS» ثم «السجلات» («Records»).",
      cuatro:
        "سترى قائمة بالسطور الموجودة لديك. اضغط زر «إضافة سجل» («Add record»).",
      cinco: "في «النوع» («Type») اختر {tipo} من القائمة المنسدلة.",
      seis: "في «الاسم» («Name») اكتب {nombre}",
      siete: "في «الوجهة» («Target») الصق {valor}",
      ocho:
        "في «حالة الـ proxy» («Proxy status») اضغط على السحابة البرتقالية. يجب أن تصبح رمادية ويظهر بجانبها «DNS فقط» («DNS only»).",
      nueve: "اترك «TTL» على «تلقائي» («Auto»). لا تغيّره.",
      diez: "اضغط «حفظ» («Save»).",
      once:
        "إذا كان الجدول أعلاه فيه أكثر من سطر، فكرّر من الخطوة 4 مع السطر التالي.",
    },

    hecho: "انتهيت. عد إلى WACheckin واضغط «تحقق».",

    avisoAntes: {
      titulo: "قبل أن تحفظ، اقرأ هذا",
      texto:
        "يجعل Cloudflare تلك السحابة برتقالية من تلقاء نفسه، بدون أن يسألك. وإذا تركتها برتقالية فلن يعمل الربط. الخطوة 8 هي الأهم في هذه الشاشة كلها.",
    },

    accesoNegado: {
      titulo: "ألا تستطيع الدخول إلى Cloudflare؟",
      texto:
        "عادة يكون الحساب باسم من أنشأ لك الموقع. اطلب منه تنفيذ هذه الخطوات أو أن يضيفك عضواً في النطاق.",
    },
  },

  // ── La nube naranja ────────────────────────────────────────────────────────
  proxy: {
    titulo: "السحابة البرتقالية: هذا هو سبب العطل دائماً",
    queEs:
      "بجانب كل سطر في DNS يعرض Cloudflare سحابة صغيرة. البرتقالية تعني أن الزيارات تمر أولاً عبر Cloudflare، والرمادية تعني أنها تذهب مباشرة.",
    porQueFalla:
      "مع السحابة البرتقالية، عندما يسأل أحدهم عن نطاقك لا يجيب Cloudflare بـ {destino}، بل يجيب بعناوينه هو. وعند التحقق نسأل، فنصل إلى Cloudflare ولا نجد السطر الذي طلبناه. وحتى لو كتبته بشكل صحيح، فهو بالنسبة لنا كأنه غير موجود.",
    porQueFalla2:
      "وهناك أثر ثانٍ أسوأ: قفل الأمان الخاص بموقعك يُصدر بعد التأكد من أن النطاق يصل إلينا. ومع السحابة البرتقالية لا يصل، فلا يمكن إصداره وسينبه المتصفح إلى أن الموقع غير آمن.",
    comoSeArregla:
      "اضغط على السحابة. ستصبح رمادية وسيتغير النص المجاور لها إلى «DNS فقط» («DNS only»). ثم احفظ. هذا كل شيء.",
    grisEsSeguro:
      "جعلها رمادية لا يترك موقعك بلا حماية. فنحن من نقدّم موقعك، بشهادته الخاصة وخلف حمايتنا نحن. ولم يكن Cloudflare في المنتصف إلا بسبب الإعداد الافتراضي الذي جاء به.",
    ttlBloqueado:
      "تفصيل يربك الكثيرين: ما دامت السحابة برتقالية، لا يسمح لك Cloudflare بتغيير TTL. وعندما تجعلها رمادية يُفتح الحقل. اتركه على «تلقائي» («Auto»).",
    etiquetaProxied: "عبر proxy («Proxied»)، سحابة برتقالية، لا",
    etiquetaSoloDns: "DNS فقط («DNS only»)، سحابة رمادية، نعم",
  },

  // ── El dominio corto (raíz) ────────────────────────────────────────────────
  raiz: {
    titulo: "إذا كنت تستخدم النطاق القصير: لا يلزمك فعل أي شيء خاص",
    texto:
      "هناك قاعدة قديمة في الإنترنت تقول إن النطاق القصير ({dominio}، بدون أي شيء قبله) لا يقبل هذا النوع من السطور. ومع معظم الشركات يضطرك ذلك إلى حلول ملتوية.",
    flattening:
      "يحل Cloudflare هذا وحده. فعندما يكون «الاسم» («Name») هو @، يطبّق ميزة خاصة به اسمها CNAME flattening: يحفظ الإحالة، وعندما يسأل أحدهم يجيب مباشرة بالعنوان النهائي. ولا تحتاج إلى تفعيل أي شيء، فهي جاهزة في كل الخطط، بما فيها المجانية.",
    avisoAjusteGlobal:
      "وما ينبغي الانتباه له: لا تغيّر خيار «CNAME flattening for all CNAME records» في «DNS» ثم «الإعدادات» («Settings»). فتطبيقه على كل شيء يجعله يتوقف عن الإجابة بالإحالات كما هي مكتوبة، ويُعطّل إثبات الملكية لخدمات أخرى لديك: البريد، Google، المتجر…",
    tituloOtro: "إذا كنت تستخدم النطاق القصير ({dominio})",
    textoOtroA:
      "في النطاق الذي لا يسبقه شيء توضع سطور من نوع A، وهي التي في الجدول. وكل الشركات تقبلها.",
    textoOtroCname:
      "كثير من الشركات لا تسمح بوضع CNAME في النطاق الذي لا يسبقه شيء. وإذا لم تسمح لك شركتك بحفظ ذلك السطر، فاستخدم «www» أو عنواناً منفصلاً مثل reservas.{dominio}، أو راسلنا ونحلها معك.",
    conflicto: {
      titulo: "إذا كان النطاق القصير فيه شيء من قبل",
      texto:
        "الاسم الواحد لا يمكن أن تكون له وجهتان في الوقت نفسه. فإذا كان في القائمة سطر من نوع A أو CNAME و«الاسم» («Name») فيه @ (أو «www» إن كنت ستستخدم www)، فاحذفه قبل إضافة سطرنا. وسينبهك Cloudflare إن لم تفعل.",
      textoOtro:
        "الاسم الواحد لا يمكن أن تكون له وجهتان في الوقت نفسه. فإذا كان في لوحتك سطر من نوع A أو CNAME بالاسم نفسه، فاحذفه قبل إضافة سطرنا.",
      comoBorrar:
        "مرّر مؤشر الفأرة فوق ذلك السطر، ثم اضغط «تعديل» («Edit») ثم «حذف» («Delete»).",
      apunta:
        "دوّن على ورقة ما كان مكتوباً فيه قبل حذفه، تحسباً للحاجة إلى التراجع.",
    },
  },

  // ── Cuánto tarda ───────────────────────────────────────────────────────────
  propagacion: {
    titulo: "كم يستغرق حتى يظهر؟",
    texto:
      "ينشر Cloudflare التغيير فوراً. والذي يستغرق وقتاً هو أن يعلم به باقي الإنترنت، فكل جهاز يحتفظ بنسخة من الدفتر لفترة حتى لا يسأل ألف مرة.",
    plazoNormal:
      "مع ضبط TTL على «تلقائي» («Auto»)، يطلب Cloudflare أن تبقى تلك النسخة خمس دقائق. وعملياً، المعتاد أن يعمل خلال خمس إلى ثلاثين دقيقة بعد الحفظ.",
    textoOtro:
      "تنشر لوحتك التغيير خلال دقائق. والذي يستغرق وقتاً هو أن يعلم به باقي الإنترنت، فكل جهاز يحتفظ بنسخة من الدفتر لفترة حتى لا يسأل ألف مرة.",
    plazoNormalOtro:
      "المعتاد أن يعمل خلال عشر دقائق إلى ساعة بعد الحفظ. وبعض الشركات تتأخر أكثر في نشر التغيير، فاحسب حتى 24 ساعة قبل أن تقلق.",
    plazoMalo:
      "إذا كان نطاقك يعرض موقعاً آخر من قبل، فقد يتأخر جهازك أنت في التخلي عما حفظه. هذا ليس عطلاً. احسب 24 ساعة قبل أن تقلق.",
    truco:
      "حيلة حتى لا ترهق نفسك بالمتابعة: افتحه في نافذة تصفح خفي، أو من الجوال ببيانات الهاتف بدل الواي فاي. هكذا ترى ما يراه عميل جديد، لا ما حفظه جهازك.",
    dominioNuevo:
      "وأمر آخر: إذا كنت قد أضفت النطاق إلى Cloudflare للمرة الأولى للتو، فقد يستغرق Cloudflare حتى 24 ساعة ليعتبره نشطاً. وحتى ذلك الحين يعمل كل شيء كأن السحب رمادية، وإن رأيتها برتقالية. انتظر حتى يظهر النطاق بحالة «نشط» («Active») قبل أن تحكم بوجود خطأ.",
    ssl:
      "عندما ينجح التحقق، نصدر قفل الأمان. وهذا يستغرق بضع دقائق إضافية. وإلى أن ينتهي، قد ينبه المتصفح إلى أن الموقع غير آمن، وهذا طبيعي ويزول وحده.",
  },

  // ── Paso 3: comprobar ──────────────────────────────────────────────────────
  paso3: {
    titulo: "لنتحقق من ذلك",
    descripcion:
      "ننظر في نطاقك ونخبرك بما وجدناه. وإذا كان شيء ناقصاً، نخبرك ما هو وكيف يُصلح.",
    boton: "تحقق الآن",
    botonReintentar: "تحقق مرة أخرى",
    comprobando: "جاري فحص سجلاتك…",
    comprobandoAyuda: "يستغرق بضع ثوانٍ.",

    resultado: {
      registroOk: "سطر DNS موجود ويشير إلينا",
      registroKo: "لا نرى السطر بعد",
      proxyOk: "السحابة رمادية، كما يجب أن تكون",
      proxyKo: "السحابة برتقالية",
      sslOk: "تم إصدار قفل الأمان",
      sslPendiente: "جاري إصدار قفل الأمان…",
      webOk: "موقعك يفتح على {dominio}، مع القفل",
      webActivando: "نقوم بتفعيل موقعك على نطاقك، مع قفل الأمان الخاص به",
      webDespues: "بعد ذلك نتحقق من أن موقعك يفتح، مع القفل",
    },

    activando: {
      titulo: "نطاقك يشير بشكل صحيح الآن. ونحن نفعّل موقعك",
      texto:
        "لم يبق سوى قفل الأمان، وهو يُصدر وحده ويستغرق عادة دقيقة أو دقيقتين. لا تغيّر شيئاً في {panel}، فنحن نتحقق من ذلك وسترى هنا متى يجهز.",
    },

    exito: {
      titulo: "تم، موقعك الآن على {dominio}",
      texto:
        "يمكنك كتابة العنوان في المتصفح ورؤيته. والعنوان القديم {actual} ما زال يعمل، فلن تتعطل الروابط التي وزّعتها من قبل.",
      verWeb: "عرض موقعي",
      soloWww: "يفتح موقعك على العنوان الذي يحتوي على «www». إذا أردت أن يعمل أيضًا بدون «www»، اطلب من مزوّد النطاق إعادة توجيه إلى العنوان الذي يحتوي على «www»، أو سجل ALIAS/ANAME على الجذر إذا كانت لوحته تسمح بذلك.",
      copiarEnlace: "نسخ العنوان",
      siguiente: "والآن ضعه في ملفاتك على Booking وAirbnb وInstagram وفي توقيع بريدك.",
    },

    pendiente: {
      titulo: "لم يجهز بعد، وهذا طبيعي",
      texto:
        "إذا كنت قد حفظته للتو في {panel}، فامهله بضع دقائق ثم اضغط مرة أخرى. ولا داعي لأن تبقى هنا، فسننبهك بالبريد فور جهوزه.",
      avisarme: "نبّهني بالبريد عندما يجهز",
    },
  },

  // ── Estados del dominio en la ficha ────────────────────────────────────────
  estados: {
    sinConectar: "غير مربوط",
    pendiente: "في انتظار السطور",
    comprobando: "جاري التحقق",
    emitiendoSsl: "جاري إصدار القفل",
    activo: "يعمل",
    error: "به عطل",
    activoAyuda: "موقعك يظهر على {dominio} والاتصال آمن.",
    activandoAyuda: "نطاقك يشير بشكل صحيح الآن. وخلال دقائق سيفتح موقعك على {dominio}، مع القفل.",
  },

  // ── Errores ────────────────────────────────────────────────────────────────
  errores: {
    formatoInvalido: {
      titulo: "هذا لا يبدو نطاقاً",
      texto: "اكتبه هكذا: midominio.com. بدون مسافات وبدون أي شيء آخر.",
    },
    conProtocolo: {
      titulo: "«https://» زائدة",
      texto: "احذفها واترك الاسم فقط: {dominio}",
    },
    conRuta: {
      titulo: "كل ما يأتي بعد الشرطة المائلة زائد",
      texto: "اترك الجزء الأول فقط: {dominio}",
    },
    sinExtension: {
      titulo: "ينقصه الامتداد",
      texto: "النطاق ينتهي بـ .com أو .es أو .net… تأكد أنك لم تكتبه ناقصاً.",
    },
    dominioNoExiste: {
      titulo: "هذا النطاق غير موجود",
      texto:
        "لا يوجد أحد مسجّل بهذا الاسم. راجع الإملاء. وإذا كنت قد اشتريته للتو، فانتظر بضع ساعات ثم حاول مرة أخرى.",
    },
    dominioCaducado: {
      titulo: "يبدو أن هذا النطاق منتهي الصلاحية",
      texto:
        "ادخل إلى الشركة التي اشتريته منها وتأكد أن التجديد مدفوع. وما دام منتهياً لا يمكن ربطه.",
    },
    yaUsadoOtraCuenta: {
      titulo: "هذا النطاق مربوط بحساب آخر",
      texto:
        "النطاق لا يمكن أن يشير إلا إلى موقع واحد في الوقت نفسه. فإذا كان {dominio} نطاقك، فراسلنا وسنفصله عن الحساب الآخر لتتمكن من استخدامه هنا.",
      contactar: "مراسلة الدعم",
    },
    yaUsadoEstaCuenta: {
      titulo: "إنه مربوط لديك بالفعل",
      texto:
        "{dominio} مستخدم في «{sitio}». افصله من هناك أو اختر عنواناً آخر لهذا الموقع.",
    },
    registrosNoAparecen: {
      titulo: "لا نرى شيئاً في نطاقك بعد",
      texto:
        "عادة تكون مسألة دقائق: فقد حفظته للتو ولم يصل بعد إلى كل مكان. انتظر عشر دقائق ثم اضغط «تحقق» مرة أخرى.",
      repasa: "وإذا مرّت نصف ساعة، فراجع ثلاثة أمور في {panel}:",
      repasa1: "أنك كتبت في «الاسم» («Name») {nombre} وليس النطاق كاملاً.",
      repasa2: "أنك ضغطت «حفظ» («Save») وأن السطر يظهر في القائمة.",
      repasa3: "أنك كتبته في {dominio} وليس في نطاق آخر من حسابك.",
    },
    proxyActivado: {
      titulo: "السحابة البرتقالية مفعّلة",
      texto:
        "نرى نطاقك، لكنه يمر عبر proxy الخاص بـ Cloudflare وهذا يحجب عنا الوجهة الحقيقية. وما دامت برتقالية، لا يمكن للتحقق ولا لقفل الأمان أن يعملا.",
      solucion:
        "ادخل إلى «DNS» ثم «السجلات» («Records»)، وابحث عن السطر الذي اسمه {nombre}، واضغط على السحابة البرتقالية حتى تصبح رمادية ويظهر «DNS فقط» («DNS only»)، ثم احفظ. بعدها عد واضغط «تحقق».",
    },
    apuntaOtroSitio: {
      titulo: "نطاقك يشير إلى مكان آخر",
      texto:
        "وجدنا {encontrado} وكنا نتوقع {destino}. وغالباً ما يكون سطراً قديماً من الموقع السابق بقي هناك.",
      solucion:
        "في «DNS» ثم «السجلات» («Records»)، احذف السطر القديم الذي يحمل الاسم {nombre} واترك سطرنا وحده.",
    },
    destinoAntiguo: {
      titulo: "القيمة التي أعطيناك إياها سابقاً لم تكن تعمل",
      texto:
        "سطرك يوصل إلى {encontrado}، وهو ما كنا قد أعطيناك إياه، لكن ذلك العنوان لا يعمل. الخطأ منا نحن، لا منك.",
      solucion: "في {panel}، عدّل السطر {nombre} واجعل قيمته {destino}. أما TXT فاتركه كما هو.",
    },
    registroDuplicado: {
      titulo: "يوجد سطران للاسم نفسه",
      texto:
        "الاسم الواحد لا يمكن أن يوصل إلى مكانين. احذف السطر الذي ليس سطرنا ثم تحقق مرة أخرى.",
    },
    error1014: {
      titulo: "إذا أظهر المتصفح «Error 1014»",
      texto:
        "هذا وجه آخر للمشكلة نفسها دائماً: السحابة البرتقالية. اجعلها رمادية على «DNS فقط» («DNS only») وستختفي.",
    },
    sslFallido: {
      titulo: "لم نتمكن من إصدار قفل الأمان",
      texto:
        "سطر DNS صحيح، لكن القفل لا يصدر. وعادة يكون السبب السحابة البرتقالية مرة أخرى، أو سطر قديم يعترض الطريق. حاول مرة أخرى بعد قليل، وإذا بقي الحال كما هو فراسلنا وسنتولى فحصه بأنفسنا.",
      reintentar: "إعادة محاولة الإصدار",
    },
    sinPermisos: {
      titulo: "لا يمكنك تغيير النطاق",
      texto: "اطلب ذلك من المسؤول عن الحساب.",
    },
    servidor: {
      titulo: "لم نتمكن من التحقق الآن",
      texto: "حدث خلل من جهتنا. حاول بعد بضع دقائق.",
    },
    guardar: "تعذّر حفظ النطاق. حاول مرة أخرى.",
  },

  // ── Desconectar ────────────────────────────────────────────────────────────
  desconectar: {
    boton: "فصل هذا النطاق",
    titulo: "هل تريد فصل {dominio}؟",
    texto:
      "لن يعود موقعك يظهر على {dominio}، وسيعود للظهور على {actual} فقط. ومن يكتب نطاقك لن يجد شيئاً إلى أن توجهه إلى مكان آخر.",
    aviso: "والسطور التي أضفتها في {panel} ما زالت موجودة. احذفها بنفسك إن لم تعد تريدها.",
    cancelar: "إلغاء",
    confirmar: "فصل",
    hecho: "تم فصل النطاق.",
  },

  // ── Dudas ──────────────────────────────────────────────────────────────────
  dudas: {
    titulo: "أسئلة تتكرر دائماً",

    correoPregunta: "هل سيعطّل هذا بريد @{dominio}؟",
    correoTexto:
      "لا. البريد يمر عبر سطور أخرى في الدفتر، وهي من نوع MX، ونحن لا نمسها. وما دمت لم تحذفها، فبريدك يبقى كما هو.",

    otraWebPregunta: "لدي موقع آخر على هذا النطاق. ماذا سيحدث له؟",
    otraWebTexto:
      "سيتوقف ظهوره، إذ يصبح النطاق يعرض هذا الموقع. وإذا أردت الإبقاء على الاثنين، فاستخدم عنواناً منفصلاً مثل reservas.{dominio} لموقع WACheckin.",

    volverAtrasPregunta: "هل يمكنني التراجع؟",
    volverAtrasTexto:
      "نعم، في أي وقت. ويُلغى من المكان نفسه الذي فُعل فيه: تحذف السطر في {panel} وتعيد السطر الذي كان لديك. ويستغرق ظهوره الوقت نفسه، بضع دقائق.",

    wwwPregunta: "هل سيعمل مع «www» وبدونها؟",
    wwwTexto:
      "نعم، إذا أضفت السطرين اللذين نعطيك إياهما. أحدهما هو الأساس والآخر يحيل إليه، حتى لا يرى Google موقعين متطابقين.",

    costePregunta: "هل يكلفني هذا شيئاً؟",
    costeTexto:
      "الربط لا يكلفك شيئاً. أما النطاق فتستمر في دفع ثمنه حيث اشتريته، كما كان الحال حتى الآن.",

    quienPregunta: "لا أظن أنني قادر على فعل هذا.",
    quienTexto:
      "هذا طبيعي، فهي أكثر خطوة مملة في العملية كلها. راسلنا وأرسل لنا نطاقك، وننجزها معك عبر الهاتف في عشر دقائق.",
  },

  // ── Botonera ───────────────────────────────────────────────────────────────
  botones: {
    atras: "رجوع",
    siguiente: "التالي",
    guardar: "حفظ",
    guardando: "جاري الحفظ…",
    cerrar: "إغلاق",
    entendido: "فهمت",
    abrirCloudflare: "فتح Cloudflare",
    soporte: "أريد مساعدة من WACheckin",
    verGuia: "عرض الدليل مرة أخرى",
  },

  avisos: {
    copiado: "تم النسخ إلى الحافظة",
    copiadoError: "تعذّر النسخ. حدّده يدوياً.",
    guardado: "تم حفظ النطاق. والآن جاء دور إضافة السطور في {panel}.",
    conectado: "موقعك يظهر الآن على {dominio}!",
    correoEnviado: "أرسلنا التعليمات إلى بريدك.",
  },
};
